import { CheckCircle2 } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, SectionHead } from "./Reveal";

export const About = () => {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="mx-auto max-w-[1500px] px-5 py-24 md:px-10 md:py-32">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <div>
          <SectionHead num={t.about.num} title={t.about.title} testid="about-head" />
          <Reveal delay={0.1}>
            <p className="text-sm md:text-base leading-relaxed text-neutral-300">{t.about.p1}</p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-neutral-400">{t.about.p2}</p>
          </Reveal>
          <Reveal delay={0.26}>
            <ul className="mt-8 space-y-3">
              {t.about.bullets.map((b, i) => (
                <li key={i} className="flex items-center gap-3 text-sm md:text-base text-neutral-200">
                  <CheckCircle2 size={18} className="shrink-0 text-[#FF5A00]" />
                  {b}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="relative">
          <div className="relative ml-auto max-w-lg">
            <div className="overflow-hidden border border-white/10">
              <img
                src="/uploads/p30.jpg"
                alt="PROALP22 works"
                loading="lazy"
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
            <div className="absolute -left-6 bottom-10 hidden w-52 overflow-hidden border border-white/10 md:block lg:-left-16">
              <img
                src="/uploads/p32.jpg"
                alt="PROALP22 rope access"
                loading="lazy"
                className="aspect-square w-full object-cover"
              />
            </div>
            <div className="absolute -right-4 -top-4 bg-[#FF5A00] px-6 py-5 text-center md:-right-8">
              <p className="font-display text-4xl md:text-5xl leading-none">7+</p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest">{t.about.badge}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
